// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"141":"f33684c1","200":"0b78be4a","364":"5e3bccdc","425":"f4889b65","427":"603965ac","453":"d855a71b","520":"196b50d8","898":"ef839d30"}[chunkId] + ".chunk.js";
};